import clsx from 'clsx'
import {useFormik} from 'formik'
import React, {useState} from 'react'
import {Button, Col, Modal, Row} from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import * as Yup from 'yup'
import HelpBubble from '../utils/HelpBubble'

const overviewSchema = Yup.object().shape({
  company: Yup.string()
    .min(150, 'Minimum 150 symbols')
    .max(3, 'Maximum 20 symbols')
    .required('company field is required'),
  description: Yup.string()
    .min(150, 'Minimum 150 symbols')
    .max(3, 'Maximum 20 symbols')
    .required('description field is required'),
  startDate: Yup.string().required('startDate field is required'),
  endDate: Yup.string().required('endDate field is required'),
})

const initialValues = {
  company: ' ',
  description: '',
  startDate: '',
  endDate: '',
}
type Props = {
  editModal: boolean
  handleEditModal: () => void
}
function ExperienceModal({editModal, handleEditModal}: Props) {
  const formik = useFormik({
    initialValues,
    validationSchema: overviewSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        //call action here
      } catch (error) {
        console.error(error)
      }
    },
  })
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  return (
    <Modal show={editModal} onHide={handleEditModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>Add your Education information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} noValidate>
          <HelpBubble
            icon='/media/icons/duotune/general/gen045.svg'
            text='Please make sure that this information is accurate. We will crosscheck he reliability of your document '
          />

          <div>
            <Row>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold  '>Company name:</label>

                  <input
                    {...formik.getFieldProps('company')}
                    placeholder='company'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.company && formik.errors.company},
                      {
                        'is-valid': formik.touched.company && !formik.errors.company,
                      }
                    )}
                    type='text'
                    name='company'
                    autoComplete='off'
                  />
                  {formik.touched.company && formik.errors.company && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.company}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={12} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold  '>description:</label>

                  <input
                    {...formik.getFieldProps('description')}
                    placeholder='description'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.description && formik.errors.description},
                      {
                        'is-valid': formik.touched.description && !formik.errors.description,
                      }
                    )}
                    type='text'
                    name='description'
                    autoComplete='off'
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.description}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>Start Date:</label>

                  <ReactDatePicker
                    className='form-control form-control-lg form-control-solid'
                    selected={startDate}
                    onChange={(date: Date) => setStartDate(date)}
                    name='startDate'
                  />

                  {formik.touched.startDate && formik.errors.startDate && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.startDate}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>End Date:</label>
                  <ReactDatePicker
                    className='form-control form-control-lg form-control-solid'
                    selected={endDate}
                    onChange={(date: Date) => setEndDate(date)}
                    name='startDate'
                  />

                  {formik.touched.endDate && formik.errors.endDate && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.endDate}</span>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleEditModal}>
          Close
        </Button>
        <Button type='submit' disabled={formik.isSubmitting || !formik.isValid} variant='primary'>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ExperienceModal
